var map = {
	"./tooth-11_implant.svg": 47049,
	"./tooth-12_implant.svg": 11394,
	"./tooth-13_implant.svg": 39627,
	"./tooth-14_implant.svg": 33732,
	"./tooth-15_implant.svg": 7709,
	"./tooth-16_implant.svg": 78166,
	"./tooth-17_implant.svg": 47135,
	"./tooth-18_implant.svg": 85944,
	"./tooth-21_implant.svg": 20152,
	"./tooth-22_implant.svg": 58851,
	"./tooth-23_implant.svg": 82522,
	"./tooth-24_implant.svg": 42613,
	"./tooth-25_implant.svg": 87836,
	"./tooth-26_implant.svg": 59223,
	"./tooth-27_implant.svg": 58126,
	"./tooth-28_implant.svg": 61001,
	"./tooth-31_implant.svg": 36575,
	"./tooth-32_implant.svg": 59844,
	"./tooth-33_implant.svg": 15581,
	"./tooth-34_implant.svg": 36514,
	"./tooth-35_implant.svg": 22539,
	"./tooth-36_implant.svg": 11296,
	"./tooth-37_implant.svg": 47081,
	"./tooth-38_implant.svg": 46254,
	"./tooth-41_implant.svg": 90510,
	"./tooth-42_implant.svg": 46549,
	"./tooth-43_implant.svg": 9500,
	"./tooth-44_implant.svg": 4227,
	"./tooth-45_implant.svg": 15546,
	"./tooth-46_implant.svg": 54689,
	"./tooth-47_implant.svg": 34040,
	"./tooth-48_implant.svg": 88991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90803;